<template>
    <div class="so-upload-nota">
        <div v-if="fullSize" class="fullSize">
            <SOTitleBar :type="'close'" :transparent="true" @back="closePreview" />
            <div class="btn-hps-wrapper">
                <button @click="hapusImage">
                    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M3 6.5H5H21"
                            stroke="#EB5757"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M8 6.5V4.5C8 3.96957 8.21071 3.46086 8.58579 3.08579C8.96086 2.71071 9.46957 2.5 10 2.5H14C14.5304 2.5 15.0391 2.71071 15.4142 3.08579C15.7893 3.46086 16 3.96957 16 4.5V6.5M19 6.5V20.5C19 21.0304 18.7893 21.5391 18.4142 21.9142C18.0391 22.2893 17.5304 22.5 17 22.5H7C6.46957 22.5 5.96086 22.2893 5.58579 21.9142C5.21071 21.5391 5 21.0304 5 20.5V6.5H19Z"
                            stroke="#EB5757"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M10 11.5V17.5"
                            stroke="#EB5757"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M14 11.5V17.5"
                            stroke="#EB5757"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                    Hapus foto
                </button>
            </div>
            <div :id="`${id}-full-size`"></div>
        </div>
        <div v-if="!cameraOpen && !fullSize">
            <label class="m-d-0 f-c-midgrey f-14 f-regular" :class="{ require: isRequired }">{{ label }}</label>
            <div class="wrap-image" v-if="images.length > 0">
                <div class="img-container" v-for="(img, idx) in images" :key="`${idx}-nota`">
                    <canvas :id="`${id}-${idx}-nota`" width="80" height="90" @click="setFullSize(idx)"></canvas>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        @click="deleteImg(idx)"
                    >
                        <path d="M0 0H24V24H4C1.79086 24 0 22.2091 0 20V0Z" fill="#FFF1F1" />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M7.52876 7.52859C7.78911 7.26824 8.21122 7.26824 8.47157 7.52859L12.0002 11.0572L15.5288 7.52859C15.7891 7.26824 16.2112 7.26824 16.4716 7.52859C16.7319 7.78894 16.7319 8.21105 16.4716 8.4714L12.943 12L16.4716 15.5286C16.7319 15.7889 16.7319 16.2111 16.4716 16.4714C16.2112 16.7317 15.7891 16.7317 15.5288 16.4714L12.0002 12.9428L8.47157 16.4714C8.21122 16.7317 7.78911 16.7317 7.52876 16.4714C7.26841 16.2111 7.26841 15.7889 7.52876 15.5286L11.0574 12L7.52876 8.4714C7.26841 8.21105 7.26841 7.78894 7.52876 7.52859Z"
                            fill="#DA1E28"
                        />
                    </svg>
                </div>
                <div class="img-container add-image" @click="setCamera(true)">
                    <img src="../../../assets/icons/camera-plus.svg" width="30" height="30" />
                    <label class="f-semi f-14 m-d-0">Tambah...</label>
                </div>
            </div>
            <div class="wrap-image-preview" v-if="images.length === 0">
                <div class="img-container add-image no-mage-preview" @click="setCamera(true)">
                    <img src="../../../assets/icons/camera-plus.svg" width="30" height="30" />
                    <label class="f-semi f-14 m-d-0">Upload...</label>
                </div>
            </div>
        </div>
        <div v-if="cameraOpen && !fullSize">
            <SOInputPhoto v-model="file" :page-title="label" @back="setCamera(false)" @input="imageInput" :id="id" />
        </div>
        <input
            type="file"
            @change="previewFiles"
            style="display: none !important;"
            :id="fileRef"
            accept="image/png, image/gif, image/jpeg"
            multiple/>
    </div>
</template>
<script>
import Compressor from "compressorjs";

import SOInputPhoto from "@/so-components/global/input/SOInputPhoto.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

export default {
    name: "SOUploadNota",
    components: {
        SOInputPhoto,
        SOTitleBar,
    },
    props: {
        isRequired: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: true,
        },
        cameraOpen: {
            type: Boolean,
            default: false,
        },
        fullSize: {
            type: Boolean,
            default: false,
        },
        images: {
            type: Array,
            default: function() {
                return [];
            },
        },
        previewImg: {
            type: Number,
        },
        label: {
            type: String,
            default: "Bukti Settlement",
        },
    },
    updated() {
        this.handleImages();
    },
    data() {
        return {
            file: null,
            maxImgSize: 2,
        };
    },
    computed: {
        fileRef() {
            return 'openGallery' + this.id;
        },
    },
    methods: {
        previewFiles(event) {
			this.imageInput(event.target.files);
		},
        async imageInput(data) {
            if (data === null) {
                return;
            }
            let images = this.images;
            let { maxImgSize, $toast } = this;

            if (data.length) {
                Object.keys(data).forEach(function(key) {
                    let imgData = data[key];
                    new Compressor(imgData, {
                        quality: 0.5,
                        maxHeight: 3000,
                        maxWidth: 3000,
                        success(result) {
                            let FileSize = result.size / 1024 / 1024;
                            if (FileSize > maxImgSize) {
                                $toast.error(
                                    `File Gambar tidak boleh lebih dari ${maxImgSize} MB, File ${
                                        result.name
                                    } ${FileSize.toFixed(2)} MB`
                                );
                            } else {
                                images.push(result);
                            }
                        },
                        error(err) {
                            $toast.error(err.message);
                        },
                    });
                });
            } else {
                images.push(data);
            }

            if (images.length > 0) {
                this.$emit("setImages", images);
            }
            await this.setCamera(false);
            await this.handleImages();
        },
        async setCamera(val) {
            if (this.isWebview()) {
                $("#" + this.fileRef).click()
                return
            }
            this.$emit("setCamera", val);
        },
        deleteImg(idx) {
            this.$emit("deleteImg", idx);
        },
        handleImages() {
            let { images, id } = this;
            images.forEach((image, idx) => {
                let el = document.getElementById(`${id}-${idx}-nota`);
                if (!el) {
                    return;
                }
                let ctx = el.getContext("2d");
                let img = new Image();
                img.src = URL.createObjectURL(image);
                img.onload = function() {
                    ctx.drawImage(img, 0, 0, 80, 90);
                };
            });
        },

        async setFullSize(idx) {
            await this.$emit("preview", idx);
            await this.$emit("setFullSize", true);
            await this.handleImageFull();
        },
        async closePreview() {
            await this.$emit("setFullSize", false);
            await this.handleImages();
        },
        handleImageFull() {
            let { images, id, previewImg } = this;
            let el = document.getElementById(`${id}-full-size`);
            let img = new Image();
            img.src = URL.createObjectURL(images[previewImg]);
            img.width = el.offsetWidth;
            img.onload = function() {
                el.appendChild(img);
            };
        },
        async hapusImage() {
            await this.$emit("deleteImg", this.previewImg);
            await this.$emit("setFullSize", false);
            await this.handleImages();
        },
    },
};
</script>

<style scoped>
.so-upload-nota .wrap-image,
.so-upload-nota .wrap-image-preview {
    display: flex;
    flex-wrap: wrap;
}
.so-upload-nota .wrap-image-preview {
    border: 2px dashed #ededed;
    border-radius: 5px;
}

.so-upload-nota .add-image {
    width: 80px;
    height: 80px;
    text-align: center;
}

.so-upload-nota .img-container {
    margin: 4px;
    position: relative;
}

.so-upload-nota .img-container canvas {
    border-radius: 3px;
    border: 1px solid #ededed;
}

.so-upload-nota .img-container svg {
    position: absolute;
    right: 0px;
}

.so-upload-nota .add-image img {
    margin-top: 13px;
}
.so-upload-nota .wrap-image .add-image {
    border: 3px dashed #ededed;
    border-radius: 3px;
    height: 92px;
}

.so-upload-nota .add-image label {
    color: #c8d0dd;
}

.so-upload-nota .no-mage-preview {
    margin-left: 37%;
}

.so-upload-nota .visibility {
    display: none;
}
.so-upload-nota .fullSize {
    position: fixed;
    z-index: 20;
}
.so-upload-nota .fullSize button {
    color: #da1e28;
    position: fixed;
    z-index: 110;
    bottom: 9px;
    right: 30px;
    font-size: 16px;
    border-radius: 3px;
    border: 1px solid #da1e28;
    padding: 4px 8px;
}
.so-upload-nota .fullSize button:active {
    background-color: lightgrey;
}

.so-upload-nota div[id$="full-size"] {
    height: 100vh;
    width: 100vw;
    background-color: black;
    align-items: center;
    display: flex;
}

.so-upload-nota .bg-transparent {
    background: rgb(0 0 0 / 25%) !important;
}

.so-upload-nota .btn-hps-wrapper {
    background: rgb(0 0 0 / 25%) !important;
    width: 100vw;
    height: 52px;
    position: fixed;
    bottom: 0px;
}
</style>
